// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"618":"05312d7c","787":"a856aad6"}[chunkId] + ".chunk.js";
};